import React from "react";
import "./GalleryPage.css";

const publicUniversities = [
  {
    name: "Universiti Malaya",
    link: "https://www.um.edu.my",
    note: "Top-ranked public university in Malaysia"
  },
  {
    name: "Universiti Kebangsaan Malaysia",
    link: "https://www.ukm.my",
    note: "Strong research and academic programs"
  },
  {
    name: "Universiti Putra Malaysia",
    link: "https://www.upm.edu.my",
    note: "Well known for science and agriculture"
  },
  {
    name: "Universiti Teknologi Malaysia",
    link: "https://www.utm.my",
    note: "Engineering and technology focus"
  },
  {
    name: "Universiti Sains Malaysia",
    link: "https://www.usm.my",
    note: "Leading research university"
  },
  {
    name: "Universiti Teknologi MARA",
    link: "https://www.uitm.edu.my",
    note: "Large public university with many campuses"
  }
];

const privateUniversities = [
  {
    name: "Monash University Malaysia",
    link: "https://www.monash.edu.my",
    note: "Australian branch campus with global recognition"
  },
  {
    name: "Sunway University",
    link: "https://university.sunway.edu.my",
    note: "Modern campus with strong industry links"
  },
  {
    name: "Taylor's University",
    link: "https://university.taylors.edu.my",
    note: "Highly ranked private university"
  },
  {
    name: "HELP University",
    link: "https://www.help.edu.my",
    note: "Known for business and psychology programs"
  },
  {
    name: "SEGi University",
    link: "https://www.segi.edu.my",
    note: "Flexible programs and affordability"
  },
  {
    name: "INTI International University",
    link: "https://newinti.edu.my",
    note: "Strong international partnerships"
  },
  {
    name: "Multimedia University",
    link: "https://www.mmu.edu.my",
    note: "Focus on IT and multimedia studies"
  }
];

function UniCard({ uni }) {
  return (
    <div className="uni-card">
      <h3>{uni.name}</h3>
      <p>{uni.note}</p>
      <a href={uni.link} target="_blank" rel="noopener noreferrer">
        Visit Website →
      </a>
    </div>
  );
}

export default function GalleryPage() {
  return (
    <div className="gal-page">
      
      <div className="gal-hero">
        <div className="gal-hero-inner">
          <h1>Credit Transfer Universities</h1>
          <p>
            Explore Malaysian universities that accept credit transfer and continue your studies smoothly.
          </p>
        </div>
      </div>

      <div className="gal-body">
        
        <div className="gal-section-intro">
          <h2>🏫 Public Universities (IPTA)</h2>
          <p>
            These universities allow credit transfer, especially from diploma to degree programs.
          </p>
        </div>

        <div className="uni-grid">
          {publicUniversities.map((uni, i) => (
            <UniCard key={i} uni={uni} />
          ))}
        </div>

        <div className="gal-section-intro">
          <h2>🏫 Private Universities (IPTS)</h2>
          <p>
            Private universities are more flexible with credit transfer and international pathways.
          </p>
        </div>

        <div className="uni-grid">
          {privateUniversities.map((uni, i) => (
            <UniCard key={i} uni={uni} />
          ))}
        </div>

        <div className="credit-note">
          <p>
            👉 Diploma holders can often transfer credits into degree programs, sometimes up to ~30%.
          </p>
        </div>

      </div>
    </div>
  );
}